import { useQuery } from "@apollo/client";
import {
  PaymentContainerApplicantUserCybersourcePublicKeyIdQueryDocument,
  ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentDocument,
  PaymentInstrument,
} from "../../../../generated";
import { Empty, Skeleton } from "antd";
import { PaymentSettings } from "./payment-settings";
import { lookupCountryQuery } from "./payment-container-country-query";
import { Country } from "../../../../types/country";
import {UpdateCardModalContainer} from "./update-card-modal.container";
import { useState } from "react";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { getItem } from "../../../shared/local-storage";

interface PaymentContainerProps {
  isDraftMode?: boolean;
}

export const PaymentContainer = (props: PaymentContainerProps) => {
  const applicantUserId = getItem('applicantUserId');
  const [isOpen, setIsOpen] = useState(false);

  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const {
    data: cybersourcePublicKeyData,
    loading: cybersourcePublicKeyLoading,
    error: cybersourcePublicKeyError,
  } = useQuery(
    PaymentContainerApplicantUserCybersourcePublicKeyIdQueryDocument
  );

  const {
    data: paymentInstrumentData,
    loading: paymentInstrumentLoading,
    error: paymentInstrumentError,
  } = useQuery(
    ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentDocument,
    {
      variables: {
        applicantUserId: applicantUserId,
      },
    }
  );

  if (paymentInstrumentLoading || cybersourcePublicKeyLoading) {
    return <Skeleton active />;
  }
  if (countryLoading || paymentInstrumentLoading) {
    return <Skeleton active />;
  }
  if (countryError || !countryData?.countries?.eventPayload?.countries) {
    return (
      <Empty
        description={`There was an error loading the country data. Please try again! ${countryError}`}
      />
    );
  }

  if (
    cybersourcePublicKeyError ||
    !cybersourcePublicKeyData?.applicantUserCybersourcePublicKeyId
  ) {
    return (
      <Empty
        description={`There was an error loading the cybersource public key data. Please try again! ${cybersourcePublicKeyError}`}
      />
    );
  }

  if (
    paymentInstrumentError ||
    !paymentInstrumentData?.applicantUserPaymentInstrument
  ) {
    return (
      <Empty description="There was an error loading the data. Please try again!" />
    );
  }

  if (!applicantUserId) {
    return <Empty description="Applicant User ID is missing" />;
  }

  const handleOpen = () => {
    console.log("Open modal");
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <ComponentQueryLoader
        loading={
          paymentInstrumentLoading ||
          cybersourcePublicKeyLoading ||
          countryLoading
        }
        error={
          paymentInstrumentError || cybersourcePublicKeyError || countryError
        }
        hasData={
          countryData?.countries?.eventPayload?.countries &&
          cybersourcePublicKeyData?.applicantUserCybersourcePublicKeyId &&
          paymentInstrumentData?.applicantUserPaymentInstrument
        }
        hasDataComponent={
          <>
            <PaymentSettings
              paymentInstrument={
                paymentInstrumentData?.applicantUserPaymentInstrument as PaymentInstrument
              }
              handleOpen={handleOpen}
              isDraftMode={props.isDraftMode}
            />
            <UpdateCardModalContainer
              applicantUserId={applicantUserId}
              cyberSourcePublicKey={
                cybersourcePublicKeyData?.applicantUserCybersourcePublicKeyId
              }
              countries={
                countryData?.countries?.eventPayload?.countries as Country[]
              }
              paymentInstrumentId={
                paymentInstrumentData?.applicantUserPaymentInstrument
                  .paymentInstrumentId
              }
              isOpen={isOpen}
              onClose={handleClose}
            />
          </>
        }
      />
    </>
  );
};

